export default "__VITE_ASSET__c96e9d1f__"